// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"646851cb","977":"68238690"}[chunkId] + ".chunk.js";
};